$(document).ready(function() {
    $('.photo').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    $(function () {
        $("input,select,textarea").not("[type=submit]").jqBootstrapValidation();
    } );

    var owl = $('.photogalery-slider-1');
    var owl2 = $('.photogalery-slider-2');

    owl.owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        items: 3,
        autoplay:false,
        autoplayTimeout:5000
    });

    owl2.owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        items: 3,
        autoplay:false,
        autoplayTimeout:5000
    });

    $('.nav-team-1 .btn-next').click(function() {
        owl.trigger('next.owl.carousel');
    });
    $('.nav-team-1 .btn-prev').click(function() {
        owl.trigger('prev.owl.carousel');
    });

    $('.nav-team-2 .btn-next').click(function() {
        owl2.trigger('next.owl.carousel');
    });
    $('.nav-team-2 .btn-prev').click(function() {
        owl2.trigger('prev.owl.carousel');
    });

    /* START menu for tablets and mobiles */
    $("#head a.mobile-btn").click(function() {
        if($('#head .nav').hasClass('active')){
            $('#head .nav').removeClass('active');
            $(this).removeClass('active');
            $(this).find('i.icon').addClass('icon-menu').removeClass('icon-close');
        }else{
            $('#head .nav').addClass('active');
            $(this).addClass('active');
            $(this).find('i.icon').removeClass('icon-menu').addClass('icon-close');
        }
    });
    /* END menu for tablets and mobiles*/

    var map = L.map('googleMap',{scrollWheelZoom: false}).setView([50.0776864, 14.4417269], 16);

    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1Ijoicm9jZXNtYW5pYyIsImEiOiJjam5hb2NzazQyZWxoM2tydWd0OHN5OThkIn0.2kz8ZH1-HH-TkOh1anDHDA'
    }).addTo(map);

	var LeafIcon = L.Icon.extend({
		options: {
            iconSize:     [71, 74],
            iconAnchor:   [0, 0]
		}
	});
	var icons  = new LeafIcon({iconUrl: 'https://www.tcm-fengshui.cz/images/mapPin.png'});

	L.marker([50.0776864, 14.4417269], {icon: icons}).addTo(map);

});
